/**
 * Téléphone mobile (iPhone, Android phone…), pas tablette ni desktop.
 */
export function isMobilePhone() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  if (/iPhone|iPod/i.test(ua)) return true;
  if (/Android/i.test(ua) && /Mobile/i.test(ua)) return true;
  if (/Windows Phone/i.test(ua)) return true;
  return false;
}
